/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Plan_LeadInputs */

const en_features_plan_lead = /** @type {(inputs: Features_Plan_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A plan for weeks in fifteen minutes.`)
};

const pl_features_plan_lead = /** @type {(inputs: Features_Plan_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan na tygodnie w kwadrans.`)
};

/**
* | output |
* | --- |
* | "A plan for weeks in fifteen minutes." |
*
* @param {Features_Plan_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_plan_lead = /** @type {((inputs?: Features_Plan_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Plan_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_plan_lead(inputs)
	return en_features_plan_lead(inputs)
});